import { render, staticRenderFns } from "./FormParticulars.vue?vue&type=template&id=16f423b4&scoped=true&"
import script from "./FormParticulars.vue?vue&type=script&lang=js&"
export * from "./FormParticulars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f423b4",
  null
  
)

export default component.exports